import React, { createContext, useContext, useReducer } from 'react';

// Initial state
const initialState = {
    config: {}
};

// Create context
const GlobalContext = createContext(initialState);

// Export the context's Consumer and Provider
export const useGlobalContext = () => useContext(GlobalContext);
export const GlobalProvider = ({ reducer, children }) => (
    <GlobalContext.Provider value={useReducer(reducer, initialState)}>
        {children}
    </GlobalContext.Provider>
);

export const globalReducer = (state, action) => {
    switch (action.type) {
        case 'SAVE_CONFIG':
            return {
                ...state,
                config: action.payload,
            };
        case 'UPDATE_CONFIG':
            return {
                ...state,
                config: {
                    ...state.config,  // Mantenemos las propiedades existentes
                    ...action.payload // Agregamos o actualizamos propiedades
                },
            };
        // Otros casos...
        default:
            return state;
    }
};
